import { PageWrap } from 'shared/components/Base/Base'
import { Button } from 'shared/components/Button/Button'
import { TextV2 } from 'shared/components/Text/TextV2'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

import { RoadError } from '../../components/Icons/Icon'
import { INDEX_PATH } from '../../Routes'

export function PageNotFound() {
  return (
    <PageWrap>
      <div className="text-center">
        <img src={RoadError} alt="" />
        <TextV2 type={TYPOGRAPHY.header1} className="mb-4">
          We can’t find the page you’re looking for.
        </TextV2>
        <Button variant="text" href={INDEX_PATH}>
          Go to Home Page
        </Button>
      </div>
    </PageWrap>
  )
}
